import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Security from "./Security";
import { useEffect } from "react";
import axios from "axios";
import baseurl from "./Baseurl";
import secureLocalStorage from "react-secure-storage";
import Manubar from "./Manubar";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import "./loader.css";
import "./shubh.css";
import { useCart } from "./CartContext";

const Shop = () => {
  let navigate = useNavigate();
  const { triggerCartRefresh } = useCart();
  let userId = secureLocalStorage.getItem("n_id");
  let [productList, setProductList] = useState([]);
  const location = useLocation();
  const subCategory_id = location.state?.subCategory_id || null;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      let data = {
        user_id: userId,
        sub_category_id: subCategory_id,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/subcategory_product_list`,
        data,
      );

      if (res?.data?.result) {
        setLoading(false);
        setProductList(res.data.data);
      }
    } catch (error) {
      console.log(error);
      setProductList([]);
      setLoading(false);
    }
  };

  let Single_products = (singleproducts) => {
    navigate(`/single_products/${singleproducts}`);
  };

  const addfevrate = async (productsid, fav_status) => {
    try {
      const items = {
        user_id: userId,
        product_id: productsid,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        triggerCartRefresh();
        fetchData();
      } else {
        toast.error(res.data.msg || "Something went wrong");
      }
    } catch (error) {
      toast.error("Product removed from favourites successfully.");
      fetchData();
    }
  };

  let loginpage = () => {
    navigate(`/login`);
  };

  return (
    <div style={{ paddingBottom: "60px" }}>
      <ToastContainer position="top-center" />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>

      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/shopscategory">Category</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {productList.length > 0
                    ? productList[0].sub_category_name
                    : ""}
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      <div className="col-lg-12">
        <div className="row justify-content-center m-5">
          <h2
            style={{
              fontSize: "1.75rem",
              fontWeight: "600",
              color: "#333",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            {productList.length > 0 ? productList[0].sub_category_name : ""}
          </h2>
          {productList.length > 0 ? (
            productList?.map((items) => {
              return (
                <div className="new-arrival-carousel-item swiper-slide col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12">
                  <div
                    className="product-card-list"
                    style={{ marginRight: "-10px", cursor: "pointer" }}
                  >
                    <div className="product-card">
                      <div className="product-thumb-nail">
                        <span>
                          <img
                            className="product-image p-2"
                            src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                            alt="image_not_found"
                            onClick={() => Single_products(items.product_id)}
                          />
                        </span>
                        <ul className="actions">
                          {userId ? (
                            items.favourite_status == 1 ? (
                              <li className="action whish-list">
                                <BsFillSuitHeartFill
                                  style={{ color: "red" }}
                                  onClick={() =>
                                    addfevrate(
                                      items.product_id,
                                      items.favourite_status,
                                    )
                                  }
                                />
                              </li>
                            ) : (
                              <li
                                className="action whish-list"
                                onClick={() =>
                                  addfevrate(
                                    items.product_id,
                                    items.favourite_status,
                                  )
                                }
                              >
                                <i className="lar la-heart" />
                              </li>
                            )
                          ) : (
                            <li className="action whish-list">
                              <button>
                                <a href="/login">
                                  <i className="lar la-heart" />
                                </a>
                              </button>
                            </li>
                          )}

                          <li className="action quick-view">
                            {userId ? (
                              <button
                                data-toggle="modal"
                                data-target="#dealsofdaymodal"
                              >
                                <i
                                  className="las la-eye"
                                  onClick={() =>
                                    Single_products(items.product_id)
                                  }
                                />
                              </button>
                            ) : (
                              <a href="/login">
                                <button>
                                  <i className="las la-eye" />
                                </button>
                              </a>
                            )}
                          </li>
                        </ul>
                      </div>

                      <div className="product-content">
                        {userId ? (
                          <a href="#">
                            <h3
                              className="product-title"
                              onClick={() => Single_products(items.product_id)}
                            >
                              {items.product_title}
                            </h3>
                          </a>
                        ) : (
                          <a href="#">
                            <h3
                              className="product-title"
                              onClick={() => loginpage(items._id)}
                            >
                              {items.product_title}
                            </h3>
                          </a>
                        )}

                        <h4 className="product-sub-title">
                          <a href="#">{items.origin}</a>
                        </h4>

                        {/* Product Specifications */}
                        <div className="product-specs mb-2">
                          <div className="spec-item d-flex justify-content-between">
                            <span className="text-muted">Weight:</span>
                            <span className="fw-bold">
                              {items.weight || "N/A"}
                            </span>
                          </div>
                          <div className="spec-item d-flex justify-content-between">
                            <span className="text-muted">Shape:</span>
                            <span className="fw-bold">
                              {items.shape || "N/A"}
                            </span>
                          </div>
                          <div className="spec-item d-flex justify-content-between">
                            <span className="text-muted">Origin:</span>
                            <span className="fw-bold">
                              {items.origin || "N/A"}
                            </span>
                          </div>
                        </div>

                        {/* Price Section */}
                        <div className="product-price-wrapp mb-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            {items.available_status?.includes("Buy") && (
                              <>
                                <span
                                  style={{
                                    background: "#ff5722",
                                    color: "#fff",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    padding: "3px 6px",
                                    borderRadius: "4px",
                                    textTransform: "uppercase",
                                    lineHeight: "1",
                                  }}
                                >
                                  Best Buy
                                </span>

                                <span
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "700",
                                    color: "#ff5722",
                                  }}
                                >
                                  ₹{items.sale_price?.toLocaleString()}
                                </span>
                              </>
                            )}
                          </div>

                          <p className="text-muted m-0">OR</p>

                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <span
                              style={{
                                background: "#ff5722",
                                color: "#fff",
                                fontSize: "11px",
                                fontWeight: "600",
                                padding: "3px 6px",
                                borderRadius: "4px",
                                textTransform: "uppercase",
                                lineHeight: "1",
                              }}
                            >
                              Leasing starts from
                            </span>

                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "#ff5722",
                              }}
                            >
                              ₹{items.lease_price?.toLocaleString()}
                            </span>
                          </div>

                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <span
                              style={{
                                background: "#ff5722",
                                color: "#fff",
                                fontSize: "11px",
                                fontWeight: "600",
                                padding: "3px 6px",
                                borderRadius: "4px",
                                textTransform: "uppercase",
                                lineHeight: "1",
                              }}
                            >
                              Security Deposit
                            </span>

                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                color: "#ff5722",
                              }}
                            >
                              ₹{items.rent_price?.toLocaleString()}
                            </span>
                          </div>
                        </div>

                        <div className="product-cart-btn-wrap">
                          <button
                            onClick={() => Single_products(items.product_id)}
                            className="btn btn-success add-to-cart-btn btn-lg w-100 py-3"
                            style={{
                              color: "#fee894",
                              background: "#160015",
                            }}
                          >
                            View Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : loading ? (
            <>
              {" "}
              <div className="row justify-content-center pb-5">
                <div class="loader"></div>
              </div>
            </>
          ) : (
            <div
              className="row justify-content-center pb-5"
              style={{
                minHeight: "250px",
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  color: "#777",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                }}
              >
                No data found
              </h3>
            </div>
          )}
        </div>
      </div>
      
    </div>
  );
};

export default Shop;
